import "%modules%/header/header";
import "%modules%/nav/nav";
import "%modules%/slider/slider";
import "%modules%/form/form";
import "%modules%/select2/select2";
import "%modules%/range/range";
import "%modules%/tab/tab";
import "%modules%/catalog/catalog";
import "%modules%/modal/modal";
import "%modules%/file/file";
import "%modules%/animate-text/animate-text";
import "%modules%/advantages/advantages";
import "%modules%/news-detail/news-detail";